import { render, staticRenderFns } from "./Cotizaciones.vue?vue&type=template&id=c9942684&scoped=true&lang=pug"
import script from "./Cotizaciones.vue?vue&type=script&lang=js"
export * from "./Cotizaciones.vue?vue&type=script&lang=js"
import style0 from "./Cotizaciones.vue?vue&type=style&index=0&id=c9942684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9942684",
  null
  
)

export default component.exports